import { render, staticRenderFns } from "./selectOrderPage.vue?vue&type=template&id=88d1ea42&scoped=true"
import script from "./selectOrderPage.vue?vue&type=script&lang=js"
export * from "./selectOrderPage.vue?vue&type=script&lang=js"
import style0 from "./selectOrderPage.vue?vue&type=style&index=0&id=88d1ea42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1ea42",
  null
  
)

export default component.exports